/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/require-default-props */
import React, { Component } from 'react';
import toastr from 'toastr';
import PropTypes from 'prop-types';
import axios from 'axios';
import { connect } from 'react-redux';
import AddIssue from '../../../shared/issues/AddIssue';
import { getUser } from '../../../../../actions/shared/user/UserActions';
import { LOGGED_IN_USER_URL } from '../../../../../services/api/auth/AuthUrl';
import { admin, NOC } from '../../../../../utils/config';
import NocNavBar from '../../../../layouts/noc/NocNavBar';

class NetworkOperationsIssue extends Component {
  static propTypes = {
    getUser: PropTypes.func.isRequired,
    firstName: PropTypes.string,
  };

  componentDidMount() {
    this.props.getUser();
    this.checkDepartment();
  }

  componentWillReceiveProps(nextProps, nextContext) {
    this.checkDepartment();
  }

  checkDepartment = async () => {
    try {
      const response = await axios.get(`${LOGGED_IN_USER_URL}`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`,
        },
      });
      if (response.data.department_id !== `${NOC}` && response.data.department_id !== `${admin}`) {
        this.props.history.push('/');
        sessionStorage.setItem('token', '');
        sessionStorage.clear();
        toastr.info('You are not allowed to view this page');
      }
    } catch (e) {
      //   console.log(e.response);
    }
  };

  render() {
    const { user } = this.props;
    const { firstName } = user;

    return (
      <div className="s-layout">
        <main className="s-layout__content col-lg-10 p-0">
          <NocNavBar currentPage="Report Issue" position={firstName} />

          <div className="container">
            <div className="row mt-5">
              <div className="col-lg-12 col-md-12 col-sm-12 mb-3 mt-4">
                <AddIssue />
              </div>
            </div>
          </div>
        </main>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user.user,
});

export default connect(mapStateToProps, { getUser })(NetworkOperationsIssue);
